import { Button } from "app/components/button";
import { Column } from "app/components/column";
import { Container } from "app/components/container";
import { DFlexResponsive } from "app/components/d-flex-responsive";
import { Row } from "app/components/row";
import { useEmpresa } from "app/contexts";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import {
  ActividadesEconomicasTable,
  ExportacionesTable,
  ImportacionesTable,
} from "..";

export function ActividadEconomicaTables() {
  const navigate = useNavigate();

  const { empresa } = useEmpresa();

  return (
    <Container>
      <Row gutter={4}>
        <Column>
          <ActividadesEconomicasTable />
          <hr />
        </Column>

        <Column>
          <ImportacionesTable />
          <hr />
        </Column>

        <Column>
          <ExportacionesTable />
          <hr />
        </Column>
      </Row>

      <div className="p-4">
        <DFlexResponsive justifyContent="end">
          <Button
            title="Anterior"
            color="secondary"
            onClick={() => navigate("../../encargados")}
          />

          <Button
            title="Siguiente"
            color="success"
            onClick={() => {
              if (!empresa.actividades_economicas.length) {
                toast.error(
                  "Por favor, agregue al menos una actividad económica."
                );

                return navigate("actividades-economicas/add");
              }

              return navigate("../../afiliacion");
            }}
          />
        </DFlexResponsive>
      </div>
    </Container>
  );
}
